/**
 * Project: academy-v2
 * File: ResetPassword
 * Created by pennycodes on 15/11/2023.
 * Copyright academy-v2
 */
import ResetPasswordForm from "@/components/auth/ResetPasswordForm.tsx";
import { useSEO } from "@/contexts/SeoContext.tsx";
import { useEffect } from "react";

export default function ResetPassword() {
  const { setTitle, setDescription } = useSEO();

  useEffect(() => {
    setTitle("Password Reset");
    setDescription("Enter your email address to reset your password");
     
  }, [setDescription, setTitle]);


  return <ResetPasswordForm />;
}
